import styled from "styled-components";
import ArrowRight from "@images/icons/table-head-arrow-icon.svg";

// Breakpoint variables
export const Breakpoints = {
  Mobile: "768px",
  Tablet: "1024px",
};

export const MediaQueries = {
  Mobile: `@media (max-width: ${Breakpoints.Mobile})`,
};

export const TableWrapperDefault = ` w-full mx-auto`;

export const TableWrapperDosing = "w-full mx-auto bg-soft_blue rounded-all_32 [&_h4]:text-dark_green [&_h4]:font-medium [&_h4]:text-center [&_h4]:py-6 border-table-light";

export const PainTable = styled.table`
  width: 1048px;
  border-collapse: collapse;
  margin: 1.5rem 0;
  overflow: hidden;
  margin: 0 auto;

  ${MediaQueries.Mobile} {
  width: 585px !important;
    th, td {
        &>strong{
            font-size: 14px;
            line-height: 18px;
        }
        &:nth-child(1) {
            width: 171px;
            padding-right: 8px !important;
        }
        &:nth-child(2) {
        text-align: center;

            &>strong{
                width: 130px !important;
                padding: 16px 8px !important;
            }
        }
        &:nth-child(3) {
            &>strong{
                width: 130px !important;
                padding: 16px 8px !important;
            }
        }
        &:nth-child(4) {
            &>strong{
                width: 130px !important;
                padding: 16px 8px !important;
            }
        }
    }
  }

  th{
    *{
      font-weight: 700;
      font-size: 16px;
    }
  }
  
th, td {
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
    color: white;
    padding:0 4px 0 4px;

    &>strong{
        border-top-left-radius: 32px;
        border-top-right-radius: 32px;
        width: 100%;
    }

    &:nth-child(2) {
        text-align: center;

        &>strong{
            background-color: #165F57;
            display: block;
            width: 100%;
            padding:16px 60px;
            margin: 0 auto;
            font-weight: 400;
            width:230px;
        }
    }

    &:nth-child(3) {
        text-align: center;
        &>strong{
        background: linear-gradient(0deg, rgba(22, 95, 87, 0.70) 0%, rgba(22, 95, 87, 0.70) 100%);
        display: block;
        width: 100%;
        padding:16px 60px;
        margin: 0 auto;
        font-weight: 400;
        width:230px;
        }
    }

    &:last-child {
        
        text-align: center;
        &>strong{
        background: linear-gradient(0deg, rgba(22, 95, 87, 0.30) 0%, rgba(22, 95, 87, 0.30) 100%);
        display: block;
        width: 100%;
        padding:16px 60px;
        margin: 0 auto;
        font-weight: 400;
        width:230px;
        }
    }
}

th{
    strong{
        font-weight: 700 !important;
    }
}
  
td {
    padding-left:4px;
    padding-right:4px;
    padding-top:0;
    padding-bottom:0;
    border-bottom: 1px solid #D3E5EA;

    &>strong{
        border-top-left-radius:0;
        border-top-right-radius: 0;
        width: 100%;
    }
}

tbody tr td {
    &:first-child {
        color: #165F57;
        padding-right: 60px;
    }
}

tbody tr:last-child td {
    border-bottom: none;
    &>strong{
        border-bottom-left-radius: 32px;
        border-bottom-right-radius: 32px;
    }
}
`;

export const ScrollableTableContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
    ${MediaQueries.Mobile} {
    margin: 0 auto 34px;
    display: block;
    max-width: 768px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

export const ScrollableTables = styled.div`
  max-width: 1204px;
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;

  ${MediaQueries.Mobile} {
    width: fit-content;
    margin-right: 16px;
  }
`;

export const SafetyTable = styled.table`
  max-width: 1204px;
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  border: hidden;
  table-layout: fixed;
  border-radius: 48px;
  padding-right: 10px;

  ${MediaQueries.Mobile} {
   width: 1204px;
    margin-right: 16px;
    th, td {
        padding: 16px 24px;
        font-size: 14px;
        line-height: 18px;
    }
  }

  tbody{
    background: white;
  }
    
  th{
   background: #a2d6b3;
   padding: 24px 16px;
   border: 2px solid #d7eedf;
   color: #165F57;
   width: auto;

   *{
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
    }
  }
    sup {
    font-size: 75%;
    }
  
  td {
    padding: 24px 32px;
    border: 2px solid #d7eedf;
    color: #707070;
    width: auto;
    vertical-align: top;
  }
`;

export const DosingTable = styled.table`
  max-width: 1204px;
  width: 100%;
  border-collapse: collapse;
  border-spacing: 2px;
  overflow: hidden;
  border: hidden;
  table-layout: fixed;
  border-radius: 32px;
  padding-right: 10px;
  border: 1px solid #CEDBD9;

  li {
    list-style-type: disc;
    padding-bottom: 8px;
    &::marker {
      color: #7AC593;
    }
  }

  ${MediaQueries.Mobile} {
    width: 720px;
    th, td {
      padding: 16px 24px;
      font-size: 14px;    
      line-height: 18px;
    }
  }
  tr:last-child td:first-child{
    border-bottom-left-radius: 32px;
  }
  tr:last-child td:last-child{
    border-bottom-right-radius: 32px;
  }

  th, td {
    padding: 24px;
    font-size: 16px;
    line-height: 20px;
    border: 2px solid #D3E5EA;
  }

  th {
    text-align: center;
    background: #165F57;
    color: #A2D6B3;
  }

  td {
    background: linear-gradient(0deg, #FCFCFC 0%, #FCFCFC 100%), #FFF;
    color: #000000b3;
    border: 2px solid #D3E5EA;
  }

  h4 {
   color: #165F57;
  }
`;  

export const AccessDosesTable = styled.table`
  max-width: 1204px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  border-collapse: collapse;
  border: hidden;
  border-radius: 32px;

  ${MediaQueries.Mobile} {
    max-width: 768px;

    th, td {
    padding-left: 2px !important;
    padding-right: 0px !important;

        &>strong{
            width: 100%;
            font-size: 14px;
            vertical-align: middle;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &:nth-child(1){
                padding: 0px !important;
                width: 96px;
            &>strong{
                padding: 0px !important;
                text-align: left;
                justify-content: flex-start;
            }
        }
        &:nth-child(2) {
            width: 103px;
            &>strong{
            padding: 8px 4px !important;
            min-height: 70px;
            line-height: 18px;
            display: flex !important;
            }
        }
        &:nth-child(3) {
            width: 103px;
            &>strong{
            padding: 15px 4px !important;
            min-height: 70px;
            line-height: 18px;
            display: flex !important;
            }
        }
    }
  }

  thead th:nth-child(2),
  thead th:nth-child(3) {
    &>strong {
      border-top-left-radius: 32px;
      border-top-right-radius: 32px;
    }
  }
  tr:last-child td:nth-child(2),
  tr:last-child td:nth-child(3) {
    &>strong {
      border-bottom-left-radius: 32px;
      border-bottom-right-radius: 32px;
    }
  }

  th {
    &>strong {
      font-weight: 700;
    }
  }

  td {
    &:nth-child(2),
    &:nth-child(3) {
      &>strong {
        color: #000000b3;
      }
    }
    &>strong {
        font-weight: 400;
    }
  }

  th, td {    
    border-bottom: 2px solid #e5e7eb;
    color: #165F57;
    padding: 0 4px 0 4px;
    vertical-align: middle;

    &>strong{
        width: 100%;
        padding: 14px 30px;
    }
    &:last-child{
        padding-right: 0px;
    }

    &:nth-child(2) {
        text-align: center;

        &>strong{
            background-color: #f7bc93;
            display: block;
            width: 100%;
            padding: 14px 30px;
        }
    }

    &:nth-child(3) {
        text-align: center;

        &>strong{
        background: linear-gradient(0deg, rgba(122, 197, 147, 0.70) 0%, rgba(122, 197, 147, 0.70) 100%), #FFF;
        display: block;
        width: 100%;
        padding: 14px 56px;
        }
    }
  `
export const AccessReimbursementTable = styled.table`
  max-width: 820px;
  width: 100%;
  margin: 0;
  overflow: hidden;
  border-collapse: collapse;
  border: hidden;

  thead tr:first-child th:nth-child(2){
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
  }
  tbody tr:last-child td:nth-child(2){
    border-bottom-right-radius: 32px;
    border-bottom-left-radius: 32px;
  }
  

  th, td {
    color: #165F57;
    font-size: 16px;
    line-height: 20px;
    padding: 14px 30px;
    border-bottom: 2px solid #D3E5EA;

    &>strong{
      font-weight: 700;
      color: #165F57;
    }
    &:nth-child(2){
      text-align: center;
      background: #A2D6B3;
      width: 393px;
    }
  }
  

  ${MediaQueries.Mobile} {
    max-width: 768px;
    th, td {
    font-size: 14px;
    line-height: 18px;
    padding: 8px;

    &:nth-child(2){
      width: 151px;
      height: 50px
    }
  }
  }
`;

export const MultiModalProtocolTable = styled.table`
  max-width: 851px;
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  border: hidden;
  border-radius: 48px;
  background: #fff;

  ${MediaQueries.Tablet} {
      width: 1024px;
      max-width: 1024px;
  }
  thead {
  
    th {
    background-color: rgba(122, 197, 147, 0.7);
    padding: 20px 45px;
    color: #165F57;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    &:nth-child(2),
    &:nth-child(3){
      position: relative;
      
      &::after {
        content: "";
        background-image: url(${ArrowRight});
        background-size: auto;
        background-repeat: no-repeat;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: -10px;
        background-position: right;
        z-index: 1;
      }
    }
    &:nth-child(2){
    padding-left: 0;
    text-align: left;
    }
    }
  }
    tbody {
    
      tr {

        &:first-child {
          td {
          border-top: none;
          }
        }

        td {
        border: 1px solid #6494A199;
        color: #000000B2;
        padding: 24px 16px;
        vertical-align: top;

          ul {
            list-style-type: disc;
            li::marker {
              color: #7AC593;
            }
          }
        }

        td:first-child {
        vertical-align: middle;
        text-align: center;
        padding: 0;
        width: 47px;
          >strong {
            font-weight: 500;
            font-size: 24px;
            line-height: 28px;
            writing-mode: vertical-lr;
            transform: rotate(180deg);
            color: #165F57;
          }
        }

        td:nth-child(2) {
          border-right: none;
          width: 187px;
        }

        td:nth-child(3) {
          background: #D3E5EA4D;
          border-left: none;
          border-right: none;
          width: 228px;
        }

        td:nth-child(4) {
          border-left: none;
          width: 391px;
        }
      } 
    }
`;

export const MultiModalProtocolTable2 = styled.table`
  max-width: 851px;
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  border: hidden;
  border-radius: 48px;
  background: #fff;
  table-layout: fixed;

  ${MediaQueries.Tablet} {
      width: 1024px;
      max-width: 1024px;
  }
  thead {
  
    th {
    background-color: rgba(122, 197, 147, 0.7);
    padding: 20px 35px;
    color: #165F57;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    border: none !important;

    &:nth-child(1),
    &:nth-child(2){
      position: relative;
      
      &::after {
        content: "";
        background-image: url(${ArrowRight});
        background-size: auto;
        background-repeat: no-repeat;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        right: -20px;
        background-position: right;
        z-index: 1;
      }
    }
    &:last-child{
      &::after {
        display: none;
      }
    }
    }
  }
    tbody {
    
      tr {

        td {
        border: 1px solid #6494A199;
        color: #000000B2;
        padding: 24px 16px;
        vertical-align: top;

          ul {
            list-style-type: disc;
            li::marker {
              color: #7AC593;
            }
          }
        }

        td:nth-child(1) {
          border-right: none;
          width: 187px;
        }

        td:nth-child(2) {
          background: #D3E5EA4D;
          border-left: none;
          border-right: none;
          width: 228px;
          ul + strong {
            margin-top: 8px;
            display: inline-block;
          }
        }

        td:nth-child(3) {
          border-left: none;
          width: 391px;
          padding-right: 30px;
        }
      } 
    }
`;

export const PediatricSurgeryTable = styled.table`
  max-width: 755px;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  border-collapse: collapse;
  border: hidden;

  tr:first-child {
    td:nth-child(2),
    td:nth-child(3) strong {
    padding: 8px 30px;
      >strong {
        font-weight: 700;
      }
    }
  }

  thead th {
    font-weight: 400;
    padding: 8px 30px;
  }

  tbody tr:first-child td:nth-child(2) {
    padding: 8px
  }
  tbody tr:first-child td:nth-child(3) strong:first-child {
      padding-top: 8px;
  }
  tbody tr:first-child td:nth-child(3) strong:last-child {
      padding-bottom: 8px;
  }
  tbody tr:first-child td:nth-child(3) strong:first-child,
  tbody tr:first-child td:nth-child(3) strong:last-child {
    em strong {
      padding: 0;
    }
  }
  
  tbody tr:first-child td:nth-child(3) em strong {
    padding: 0!important;
  }


  tbody tr:first-child {
    td:nth-child(2),
    td:nth-child(3) strong:not(:last-child) {
      border-top-left-radius: 32px;
      border-top-right-radius: 32px;
    }
  }
  tbody tr:first-child {
    td:nth-child(2),
    td:nth-child(3) strong,
    td:nth-child(3) em {
      padding: 0;
    }
  }
  tbody tr:last-child {
    td:nth-child(2),
    td:nth-child(3) strong {
      border-bottom-right-radius: 32px;
      border-bottom-left-radius: 32px;
    }
  }
  

  th, td {
    color: #165F57;
    font-size: 16px;
    line-height: 20px;
    color: #000000B2;
    text-align: center;

    strong {
      font-weight: 700;
      text-align: center;
      display: block;
      width: 100%;
    }
  }
    td {
      border-bottom: 2px solid #D3E5EA;
      padding: 14px 30px;

      &:first-child {
        color: #165F57;
        text-align: left;
        padding: 14px 8px;
        width: 261px;
        >strong {
          text-align: left;
        }
      }
      &:nth-child(2){
        background: #f7bc93;
        >strong {
          font-weight: 400;
        }
      }
      &:nth-child(3){
        padding: 0 0 0 8px;
        >strong,
        >em {
        background: #A2D6B3;
        }
        >em {
          font-weight: 700;
          color: #165F57;
          display: block;
          width: 100%;
          padding-top: 4px;
          padding-bottom: 4px;
          font-style: normal;
        }
        >strong {
            font-weight: 400;
            padding: 14px 30px;
        }
      }
    }
  

  ${MediaQueries.Mobile} {
  th:nth-child(2) {
    padding: 8px 20px;
  }
    th, td {
    font-size: 14px;
    line-height: 18px;

    &:nth-child(1){
      width: 187px;
      padding: 8px;
      strong {
        width: 187px;
      }
      em{
        
      }
    }
    &:nth-child(2){
      min-width: 200px;
      padding: 14px 40px;
    }
    &:nth-child(3){
      width: 200px;
      strong {
        width: 200px;
      }
    }
  }
  }
`;

export const OtherTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
  overflow: hidden;
`;